import { api_get, api_post, api_put, api_delete } from '@lf/api-client/lfApi';

const BASE_PATH = '/blacklist';

export async function listBlacklists(childProfileId, setError = null) {
    if (!childProfileId) {
        throw new Error('childProfileId is required to list blacklists');
    }

    const response = await api_get(
        `${BASE_PATH}/`,
        { child_profile_id: childProfileId },
        setError
    );

    if (response && response.status === 200) {
        return response.data.blacklists;
    }
    return [];
}

export async function getBlacklist(blacklistId, setError = null) {
    const response = await api_get(`${BASE_PATH}/${blacklistId}`, undefined, setError);

    if (response && response.status === 200) {
        return response.data;
    }
    return null;
}

export async function createBlacklist(childProfileId, text, setError = null) {
    const response = await api_post(
        `${BASE_PATH}/`,
        {
            child_profile_id: childProfileId,
            text,
        },
        setError
    );

    if (response && response.status === 201) {
        return response.data;
    }
    return null;
}

export async function updateBlacklist(blacklistId, text, setError = null) {
    const response = await api_put(
        `${BASE_PATH}/${blacklistId}`,
        { text },
        setError
    );

    if (response && response.status === 200) {
        return response.data;
    }
    return null;
}

export async function deleteBlacklist(blacklistId, setError = null) {
    const response = await api_delete(`${BASE_PATH}/${blacklistId}`, undefined, setError);

    if (response && (response.status === 200 || response.status === 204)) {
        return true;
    }
    return false;
}
